module.exports = __webpack_public_path__ + "img/EstudianteOK.baec73b9.png";